const carouselItems = [
  {
    tag: '热播剧集',
    title: '《暗夜追踪》第三季重磅回归',
    desc: '悬疑烧脑再升级，全网独播中，单集播放量突破5000万，口碑炸裂好评如潮',
    image: 'https://readdy.ai/api/search-image?query=Dark%20mystery%20thriller%20scene%20with%20detective%20in%20rainy%20city%20night%2C%20neon%20reflections%20on%20wet%20asphalt%2C%20cinematic%20noir%20atmosphere%2C%20dramatic%20shadows%20and%20moody%20lighting%2C%20film%20noir%20aesthetic&width=600&height=380&seq=carousel-01-2026&orientation=landscape',
    meta: '更新至第8集 · 9.2分',
  },
  {
    tag: '院线大片',
    title: '暑期档票房冠军《星际征途》',
    desc: '史诗级科幻巨制，视觉特效震撼人心，累计票房突破38亿，丫丫影院高清上线',
    image: 'https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20space%20scene%20with%20massive%20spaceship%20fleet%20orbiting%20distant%20planet%2C%20nebula%20colors%20in%20deep%20cosmic%20background%2C%20cinematic%20widescreen%20composition%2C%20dramatic%20lighting&width=600&height=380&seq=carousel-02-2026&orientation=landscape',
    meta: '4K超清 · 9.5分',
  },
  {
    tag: '综艺爆款',
    title: '《声动亚洲》第五季火热开播',
    desc: '全亚洲顶级音乐人同台竞技，神仙打架名场面不断，每周五晚8点准时更新',
    image: 'https://readdy.ai/api/search-image?query=Grand%20music%20competition%20stage%20with%20dramatic%20spotlights%20and%20colorful%20stage%20lighting%2C%20concert%20atmosphere%20with%20fog%20effects%2C%20professional%20music%20show%20production%2C%20vibrant%20and%20energetic&width=600&height=380&seq=carousel-03-2026&orientation=landscape',
    meta: '每周五更新 · 9.0分',
  },
  {
    tag: '动漫精选',
    title: '《灵笼》终章剧场版独家上线',
    desc: '国漫巅峰之作迎来史诗级大结局，末日科幻题材视觉盛宴，粉丝苦等三年终圆梦',
    image: 'https://readdy.ai/api/search-image?query=Post%20apocalyptic%20anime%20style%20cityscape%20with%20mechanical%20structures%20and%20survivors%2C%20dramatic%20sunset%20lighting%2C%20detailed%20sci-fi%20art%20style%2C%20atmospheric%20and%20emotional%20mood&width=600&height=380&seq=carousel-04-2026&orientation=landscape',
    meta: '剧场版全一集 · 9.7分',
  },
  {
    tag: '韩剧专区',
    title: '《财阀家的小女儿》中字同步',
    desc: '年度现象级韩剧，收视率屡破纪录，豪门恩怨与复仇剧情引人入胜，全网热议',
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20Korean%20drama%20scene%20with%20elegant%20business%20office%20and%20stylish%20characters%2C%20warm%20modern%20interior%20design%2C%20soft%20cinematic%20lighting%2C%20sophisticated%20and%20romantic%20atmosphere&width=600&height=380&seq=carousel-05-2026&orientation=landscape',
    meta: '更新至第12集 · 9.3分',
  },
  {
    tag: '纪录片',
    title: '《地球脉动III》4K震撼上线',
    desc: 'BBC历时五年倾力打造，前所未有的自然奇观，每一帧都是精美壁纸级别的视觉享受',
    image: 'https://readdy.ai/api/search-image?query=Breathtaking%20nature%20documentary%20scene%20with%20diverse%20wildlife%20in%20pristine%20landscape%2C%20golden%20hour%20light%20over%20mountains%20and%20ocean%2C%20cinematic%20aerial%20photography%20style%2C%20epic%20natural%20beauty&width=600&height=380&seq=carousel-06-2026&orientation=landscape',
    meta: '全6集 · 9.8分',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-10 md:mb-14 gap-4">
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
              编辑推荐
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
              焦点专题
            </h2>
            <p className="mt-2 text-foreground-500 text-sm md:text-base">
              本周最受关注的影视内容，编辑团队精挑细选
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <article
              key={item.title}
              className="group bg-white rounded-2xl overflow-hidden hover:bg-primary-50/30 transition-colors duration-300"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-black/60 text-white text-xs font-medium backdrop-blur-sm">
                  {item.tag}
                </span>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 mb-2 line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-3 line-clamp-2">
                  {item.desc}
                </p>
                <div className="flex items-center gap-2 text-xs text-accent-600">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-accent-500"></i>
                  </div>
                  {item.meta}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}